import React, { useEffect, useState } from "react";
import MD5 from "crypto-js/md5";
import { Avatar, IconButton, Menu, MenuItem } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";

function GravatarAvatar({
  email,
  size,
  onLogout,
}: {
  email: string;
  size: number;
  onLogout: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [gravatarUrl, setGravatarUrl] = useState("");
  const navivate = useNavigate();

  useEffect(() => {
  // Gravatar uses a MD5 hash of the user's email address
   const hash = MD5(email ? email.trim().toLowerCase() : "")
      .toString()
      .toLowerCase();
    setGravatarUrl(`https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`);
  }, [email, size]);

  // Handling click of the avatar icon
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // Handling menu close
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navivate("/profile");
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Avatar src={gravatarUrl} alt="user avatar">
          <AccountCircleIcon />
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfileClick}>My Profile</MenuItem>
        
        <MenuItem onClick={onLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
}

export default GravatarAvatar;
